import React from 'react';
import { Badge, useToggle } from '@oforce/global-components';

import { ActionDropdown } from '../../../components/table-2.0';
import { backendNameToLabel } from '../../../utils/formatting';

import { CreateUpdate, Remove } from '.';
import { RetailCommissionPricingOptionsTooltip } from '../../../components/sharedComponents/components';
import { usePolicyPricings } from '../../policyPricing/hooks';
import { ACCOUNT_ROLES, ACCOUNT_TYPES, HideFromRoles, ShowForTypes } from '../../../shared/activeAccount';
import { formatPricing } from '../../exposureElections/utils';

export default function RetailCommissionsTableRow({ policyId, retailCommission }) {
  const [showEdit, toggleEdit] = useToggle();
  const [showRemove, toggleRemove] = useToggle();
  const { pricings: pricingOptions } = usePolicyPricings({ policyId });
  const { CARRIER, BROKER } = ACCOUNT_TYPES;
  const { EXPOSURE_MANAGER } = ACCOUNT_ROLES;

  const pricingOptionsBadgeText = retailCommission?.appliesToAllPricing
    ? `All Pricing Options (${pricingOptions?.length})`
    : `Some Pricing Options (${retailCommission?.pricingOptionIds?.length})`;

  return (
    <>
      <tr>
        <td>{retailCommission?.name}</td>
        <td>
          <div className="font-weight-500">{backendNameToLabel(retailCommission?.rateMode)}</div>
          <div className="font-weight-300 fs-sm text-muted">
            {formatPricing({
              rate: retailCommission?.rate,
              rateMode: retailCommission?.rateMode,
              isPercentageFactor: true
            })}
          </div>
        </td>
        <td>
          <Badge
            size="sm"
            id={`a-${retailCommission?.id}`}
            color="secondary"
            className="cursor-pointer"
            iconAfter={['far', 'info-circle']}
          >
            {pricingOptionsBadgeText}
          </Badge>
          <RetailCommissionPricingOptionsTooltip pricingOptions={pricingOptions} retailCommission={retailCommission} />
        </td>
        <ShowForTypes types={[CARRIER, BROKER]}>
          <HideFromRoles roles={[EXPOSURE_MANAGER]}>
            <td align="right">
              <ActionDropdown onEdit={toggleEdit} onRemove={toggleRemove} />
            </td>
          </HideFromRoles>
        </ShowForTypes>
      </tr>

      <CreateUpdate isOpen={showEdit} toggle={toggleEdit} retailCommission={retailCommission} policyId={policyId} />
      <Remove isOpen={showRemove} toggle={toggleRemove} retailCommission={retailCommission} policyId={policyId} />
    </>
  );
}
